import verge from '../vendor/verge';
import {konsole, _u, $, elemIsVisible, _ga, fastdom, doT, _, rx, trapFocus} from '../util';
import {dealers, numOfDealers, seriesCodeRxs} from '../setup';
import Slider from './Slider';
import router from '../routerAndLayout';


const datarx = {
  jcw: /John Cooper Works/i,
  all4: /all4/i,
  mini: /mini\s?/ig,
  xajtos: /(\d)\s?ajt[oó]s/ig,
  anyspace: /\s/g,
  sport: /sport/i,
  automata: /automata/i,
  dashOrDot: /[.-]/,
  price: /(\d)(?=(\d\d\d)+(?!\d))/g,
  fuel_hibrid: /hibrid/i,
  fuel_benzin: /benzin/i,
  fuel_dizel: /dízel|diesel/i,
  fuel_elektromos: /elektromos/i,
  power_ec: /hibrid|elektromos/i,
  km: /&nbsp;km|\s+km/i
};

// eslint-disable-next-line no-unused-vars
let _isMobileDevice = false;
$(window).resize(() => {
  _isMobileDevice = !_u.isMobile && $(window).width() > 760;
}).resize();


const _tpl = {

  wrapValWithLink: (v, href) => `<a href="${href}">` + v + "</a>",

  wrapDealerValWithContactLink: (extraClass, v, href) => (
    `<a class="contact-link${extraClass ? ' ' + extraClass : ''}" data-dlrid="${href}" href="#foot-addresses-${href}">` + v + "</a>"
  ),

  wrapValWithSpan: (v) => "<span>" + v + "</span>",

  formatPrice: (ar, _suffix) => {
    ar = (ar || 0) - 0;
    if (ar > 9999) {
      ar = ar.toFixed(0).replace(datarx.price, "$1&nbsp;");
    }
    return ar + (_suffix || "&nbsp;Ft");
  },

  whereisitNames: (dealer) => {
    const r = {};
    for (let i = 0; i < dealer.length; i++) {
      r[dealer[i]] = dealers[dealer[i]] || "unkown dealer";
    }
    return r;
  }
};


class ResultItem {
  constructor(item, __CarSearch, uniqId) {
    this.__CarSearch = __CarSearch;
    this.data = item;
    this.hidden = false;
    this.expanded = false;
    this.id = "result-item-" + uniqId;
    this.cleanTrap = null;
    this.data = $.extend(
      {
        saleClass: "",
        saleDefaultLeadCtxId: null,
        id: this.id,
        htmlId: this.id + "--" + item._id,
        weight: 0,
        alwaysontop: false,
        sticker: {},
        code: "",
        _id: "",
        _note: "",
        model: "N/A",
        ctx: [],
        extras: [],
        type: "N/A",
        color: "N/A",
        engine: "N/A",
        horsepower: "N/A",
        transmission: "N/A",
        registrated: "",
        sold: false,
        availability: false,
        km_approx: false,
        newcar: false,
        mileage_km: 0,
        dealer: "",
        warranty: "N/A",
        prc_baseprice: 0,
        prc_extrasprice: 0,
        prc_fullprice: 0,
        prc_regtax: 0,
        prc_instant_price: 0,
        prc_savings: 0,
        prc_ecob_price: 0,
        prc_ecob_by_price: 0,
        prc_fact_price: 0,
        prc_inno_price: 0,
        pdf: "",
        img: ""
      },
      item
    );

    this.data.sold = this.data.sold === 1 || this.data.sold === true;
    // if (this.data.extras.length === 1 && this.data.extras[0] === "") {
    //   this.data.extras = [];
    // }
    if (this.data.sold) {
      this.data.availability = "Elkelt";
    }
    this.data.color_code = _.snakeCase(this.data.color);
    this.data.highlight_color = this.data.color_code;
    this.data.prc_instant_price = this.data.prc_instant_price - 0;
    this.data.name = this.data.model + " | " + this.data.type;

    this.data.name_f = (this.data.name + (this.data.title_suffix
      ? '" <small class="suffix">' + this.data.title_suffix + "</small>"
      : ""
    )).replace(datarx.mini, '<span class="mini">MINI</span> ')
      .replace(datarx.jcw, '<span class="jcw" title="John Cooper Works">JCW</span>')
    ;
    this.data.all4 = this.data.name.search(datarx.all4) > -1;

    this.data.drivewheel_icon = this.data.all4 ? '4-wheel' : '2-wheel';
    this.data.drivewheel = this.data.all4 ? 'összkerék' : 'elsőkerék';
    this.data.alt = this.data.model + " - " + this.data.type + " " + (this.data.title_suffix
      ? this.data.title_suffix
      : ""
    );
    this.data.pdf = this.data.folder + ".pdf";
    this.data.year = this.data.registrated.split(datarx.dashOrDot)[0];

    this.data.prc_savings = Math.round(
      this.data.prc_fullprice - this.data.prc_instant_price
    );

    this.data.transmission_icon = this.data.transmission.search(datarx.automata) > -1 ? (
      this.data.transmission.search(datarx.sport) > -1 ? 'sportautomatic' : 'automatic'
    ) : 'manual';

    this.data.transmission_f = this.data.transmission.search(datarx.automata) > -1
      ? "Automata"
      : "Manuális"
    ;

    this.data.engine_f = this.data.engine.search(datarx.fuel_hibrid) > -1 ? 'Hibrid' : this.data.engine;

    this.data.fuel_icon = (
      this.data.engine.search(datarx.fuel_elektromos) > -1 ? 'electric-badge' : (
        this.data.engine.search(datarx.fuel_hibrid) > -1 ? 'fuel-type-phev' : (
          'petrol'
        )
      )
    );
    this.data.power_icon = (
      this.data.engine.search(datarx.power_ec) > -1
        ? "electric-power" : "power"
    );

    this.data.prc_baseprice_f = _tpl.formatPrice(this.data.prc_baseprice);
    this.data.prc_extrasprice_f = _tpl.formatPrice(this.data.prc_extrasprice);
    this.data.prc_fullprice_f = _tpl.formatPrice(this.data.prc_fullprice);
    this.data.prc_regtax_f = _tpl.formatPrice(this.data.prc_regtax);
    this.data.prc_instant_price_f = _tpl.formatPrice(this.data.prc_instant_price);
    this.data.prc_ecob_price_f = _tpl.formatPrice(this.data.prc_ecob_price);
    this.data.prc_ecob_by_price_f = _tpl.formatPrice(this.data.prc_ecob_by_price);
    this.data.prc_fact_price_f = _tpl.formatPrice(this.data.prc_fact_price);
    this.data.prc_inno_price_f = _tpl.formatPrice(this.data.prc_inno_price);
    this.data.prc_savings_f = _tpl.formatPrice(this.data.prc_savings);
    this.data.mileage_km_f = this.data.mileage_km !== false && !this.data.newcar && this.data.mileage_km !== 0
      ? _tpl.formatPrice(this.data.mileage_km, "&nbsp;km")
      : ""
    ;

    this.data.mileage_km_no_unit = this.data.mileage_km_f.replace(datarx.km, '');

    this.data.dealer = _tpl.whereisitNames(this.data.dealer);
    this.data.dealer_without_distinct = this.data.dealer;
    if (
      this.__CarSearch.setup.distinctDealer &&
      this.data.dealer[this.__CarSearch.setup.distinctDealer]
    ) {
      this.data.dealer = _.pick(
        this.data.dealer,
        this.__CarSearch.setup.distinctDealer
      );
    }

    this.data.distinctDealer = this.__CarSearch.setup.distinctDealer;

    this.data.dir = "/img/vehicles/" + this.data.folder + "/";

    // if (this.data.gallery && this.data.gallery.length) {
    //   for (let i = 0; i < this.data.gallery.length; i++) {
    //     this.data.gallery[i] = this.data.dir + this.data.gallery[i];
    //   }
    // }

    if (!$.isArray(this.data.gallery) || this.data.gallery.length < 1) {
      this.data.gallery = ['/img/vehicle_no_image.png'];
    }

    this.data.firstpic = this.data.gallery[0].replace(".jpg", "_medium.jpg");

    this.data.availabile_anywhere = _.values(this.data.dealer_without_distinct).length === numOfDealers;
    const availabile_anywhere_distinct = _.values(this.data.dealer).length === numOfDealers;
    // const availabile_anywhere_distinct = this.data.availabile_anywhere

    this.data.dealer_multiple = _.size(this.data.dealer) > 1;
    this.data.dealer_label = (
      "Kereskedő" + (availabile_anywhere_distinct || this.data.dealer_multiple ? "k" : "")
    );

    this.data.dealers = availabile_anywhere_distinct
      ? _tpl.wrapValWithLink('Összes kereskedés', '#foot-addresses')
      : _.map(
        this.data.dealer,
        _tpl.wrapDealerValWithContactLink.bind(
          this.data.dealer, this.data.dealer_multiple ? 'multiple-dealer' : 'one-dealer'
        )
      ).join(" | ")
    ;

    this.data.path = (
      this.__CarSearch.setup.urlpath
        ? this.__CarSearch.setup.urlpath
        : this.data.newcar ? "/new/" : "/used/"
    ) + this.data._id;
    this.data.parentPath = router.getParentPath(this.data.path);
    this.data.url = this.data.path + router.getParams();

    this.data.seriesName = this.data.model
      .toLowerCase()
      .replace(datarx.mini, "")
      .replace(datarx.xajtos, "$1door")
      .replace(datarx.anyspace, "");

    this.data.seriesCode = this.data.seriesCode || this.determineSeriesCode();

    // allModelType[this.data.model] = this.data.model;
    this.highlighted = false;
    this.$out = $(this.templateLead(this.data)).attr("data-id", this.id);
    this.$pic = this.$out.find("img.pic");
    this.inviewport = false;
    this.visible = false;
    this.$lead = this.$out.find(".lead");
    this.$details = this.$out.find(".details");
    this.$form = null;
    this.$specs = null;
    this.$close = this.$out.find("a.close");
    this.destroyTimer = null;
    this.sliderDetails = null;
    this.sliderLead = new Slider(this.$out.find(".slider"), {
      initialIndex: 0,
      autoplay: false,
      dotsEnabled: false
    });
  }


  init() {
    this.$out.on("click", ".entry, .car-condition", this, this._events.activateClick);
    this.$out.on("click keypress", ".contact-link", this, this._events.toggleAddress);
    this.$out.on("click", ".more", this, this._events.activateCtaClick);
    this.$out.on("click", ".title-link", this, this._events.activateToggle);
    this.$out.on("click", ".slide-img-link", this, this._events.activateOrOrigPicClick);
    this.$out.on("click", ".close-lead-x, .close-x", this, this._events.inactivateClick);
    this.$out.on("click", ".toggle-slider-size", this, this._events.toggleSliderSize);
    this.$out.on("click", ".prev-result", this, this._events.prevItem);
    this.$out.on("click", ".next-result", this, this._events.nextItem);

    for (let i = 0, jpg_med, jpg_orig; i < this.data.gallery.length; i++) {
      jpg_orig = this.data.gallery[i];
      if (jpg_orig.search(rx.is_in_the_img_forder) === -1) {
        jpg_orig = this.data.dir + jpg_orig;
      }
      jpg_med = jpg_orig
        .replace(".jpg", "_medium.jpg")
        .replace(".png", "_medium.jpg");
      // jpg_orig = jpg_orig.replace('.jpg', '.png');
      this.sliderLead.addSlide(
        '<a tabindex="-1" href="' + this.data.path + '" data-grp="' + this.id + '" class="slide-img-link jslink" target="_blank">' +
        "<img " +
          'data-src="' + jpg_med + '" ' +
          'data-grp="' + this.id + '" ' +
          'data-origsrc="' + jpg_orig + '" ' +
          'alt="' + this.data.alt + " (kép " + (i + 1) + ')" />' +
        "</a >"
        ,
        i
      );
    }
  }

  recalc() {
    fastdom.measure(this._recalc, this);
  }

  _recalc() {
    if (elemIsVisible(this.$out[0])) {
      this.visible = true;
      this.inviewport = verge.inViewport(this.$lead[0], -100);

      if (this.inviewport) {
        this.sliderLead.init();
      }
    }
    else {
      this.inviewport = false;
      this.visible = false;
    }
  }

  determineSeriesCode() {
    let m;
    let ret = null;
    const codes = seriesCodeRxs;

    for (const code in codes) {
      if (
        codes.hasOwnProperty(code) &&
        ((this.seriesName &&
            (m = this.seriesName.match(codes[code])) &&
            m.length) ||
          ((m = this.data.name.match(codes[code])) && m.length))
      ) {
        ret = code;
        break;
      }
    }

    if (!ret) {
      konsole.log("seriesCode couldn't be determined", this.data);
    }

    return ret;
  };

  appendToResult() {
    this.$out.appendTo(this.__CarSearch.$.resultList);
  };

  activateItem({silent = false, hash, params} = {}) {
    router.setPathPort({path: this.data.path, silent, hash, params });
  }

  inactivateItem({silent = false} = {}) {
    router.unsetPathPort({path: this.data.path, silent});
  }

  renderDetails() {
    if (this.destroyTimer) {
      this.$out.removeClass("expanded-animation-end");
      clearTimeout(this.destroyTimer);
      this.destroyTimer = null;
    }
    if (this.$form === null) {
      const html = this.templateDetails(this.data);
      this.$details.append(html);
      this.$form = this.$out.find(".form");
      this.$specs = this.$out.find(".specs");
      this.sliderDetails = this.sliderLead.clone(this.$details.find(".slider-wrp"), {
        dotsEnabled: true
      });
      this.sliderDetails.init();
    }
    setTimeout(() => {
      this.detailsScrollTo();
    }, 10);
  }

  destroyDetails(fn) {

    this.$out.addClass("expanded-animation-end");
    this.sliderLead.setSlide(this.sliderDetails.getActiveSlideIndex());

    this.destroyTimer = setTimeout(() => {
      this.$out.removeClass("expanded-animation-end");
      this.sliderDetails.destroy();
      this.sliderDetails = null;
      this.$details.empty();
      this.$form = null;
      this.$specs = null;
      if (typeof fn === "function") {
        fn();
      }
    }, 600);
  }

  detailsScrollTo(hashOrDom = null) {
    let to = 0;

    if (typeof hashOrDom === "string" || hashOrDom === null) {
      const hash = ((hashOrDom || window.location.hash).replace('#', ''));
      if (hash) {
        to = $('#' + hash);
      }
    }
    else if (hashOrDom && hashOrDom.jquery && hashOrDom.length) {
      to = hashOrDom;
    }
    else if (hashOrDom && hashOrDom.nodeType) {
      to = $(hashOrDom);
    }
    else if (typeof hashOrDom === "number") {
      to = hashOrDom;
    }
    else {
      console.warn('detailsScrollTo: invalid argument', hashOrDom);
      return;
    }


    if (this.expanded && ((typeof to === "number" && to >= 0) || to.length)) {
      fastdom.mutate(() => {
        this.$details.scrollTo(to, 500);
      });
    }
  }

  trapFocus() {
    this.untrapFocus();

    if (this.expanded) {
      this.cleanTrap = trapFocus(this.$details[0], this.$out.find('.close-x')[0], (e) => {
        // close detials on ESC if not in form input
        if (e.keyCode === 27 && !$(e.target).is('input, textarea, select')) {
          this.hideDetails({rescroll: true});
        }
      });
    }
  }

  untrapFocus() {
    if (typeof this.cleanTrap === "function") {
      this.cleanTrap();
      this.cleanTrap = null;
    }
  }

  showDetails({
    // setRoute,
    scrollAnim = true
  } = {}) {
    if (this.expanded) { return; }

    this.renderDetails();


    this.sliderLead.init();


    this.recalc();

    this.__CarSearch.closeAllInAnyInstance();

    document.documentElement.classList.add('item-in-focus');

    if (this.timerFocus) {
      clearTimeout(this.timerFocus);
      this.timerFocus = null;
    }
    this.timerFocus = setTimeout(() => {
      document.documentElement.classList.add('item-in-focus-enter');
    }, 500);


    this.$out.addClass("expanded").removeClass('collapsed');
    if (!this.inviewport) {
      _u.scrollTo(this.$out, scrollAnim ? 500 : 0, null,
        0
        // 0 - Math.max(30, Math.min(window.innerHeight / 6, 500))
      );
    }
    this.formLoaded = 0;

    if (!this.data.sold) {
      const dealerProps = _.keys(this.data.dealer);

      this.__CarSearch.formApiEmbedded
        .setData({
          id: this.data._id,
          path: this.data.path,
          seriesCode: this.data.seriesCode,
          dealerProps: dealerProps,
          dealers: this.data.dealer,
          ctx_whitelist: this.data.ctx_whitelist,
          saleDefaultLeadCtxId: this.data.saleDefaultLeadCtxId,
          callback: () => {
            if (this.formLoaded > 0) {
              setTimeout(() => this.detailsScrollTo(this.$form[0]), 10);
            }
            this.formLoaded += 1;
          }
        })
        .attach(this.$form)
      ;

      this.__CarSearch.$.dealer_addresses
        .find(".dealer-address")
        .removeClass('active')
        .hide()
        .filter("." + dealerProps.join(", ."))
        .show()
      ;
      this.__CarSearch.$.instructions.appendTo(this.$details.find('.addresses'));
      setTimeout(() => this.detailsScrollTo());

    }

    // if (setRoute) {
    //   router.setPathPort({path: this.data.path, silent: true});
    // }
    this.expanded = true;
    this.sliderLead.setTimeOut();
    this.trapFocus();

    _ga('send', {
      hitType: 'event',
      eventCategory: 'vehicle',
      eventAction: 'view',
      eventLabel: this.data._id
    });
  };

  hideDetails({
    rescroll = false
    // unsetRoute
  } = {}) {
    if (!this.expanded) {
      return this;
    }

    this.__CarSearch.formApiEmbedded.detach();
    this.__CarSearch.$.instructions.detach();
    this.destroyDetails(() => {

    });

    this.$out.removeClass("expanded").addClass('collapsed');
    document.documentElement.classList.remove('item-in-focus');
    document.documentElement.classList.remove('item-in-focus-enter');

    // if (rescroll) {
    //   _u.scrollTo(this.$out, 300);
    // }

    this.expanded = false;

    this.untrapFocus();
    this.sliderLead.clearTimeOut();

    // if (unsetRoute) {
    //   router.unsetPathPort({path: this.data.path, silent: true});
    // }
  };

  hide() {
    if (!this.hidden) {
      this.hidden = true;
      this.$out.hide();
    }
  };

  setHighlight() {
    if (!this.highlighted) {
      this.$out.addClass("highlight");
      this.highlighted = true;
      this.sliderLead.freeze(-2);
    }
    return this;
  };

  unsetHighlight() {
    if (this.highlighted) {
      this.$out.removeClass("highlight");
      this.highlighted = false;

      if (!this.expanded) {
        this.sliderLead.freeze(1);
      }
    }
    return this;
  };

  show() {
    if (this.hidden) {
      this.hidden = false;
      this.$out.show();
    }
  };

  stepItem(nextOrPrev) {
    if (nextOrPrev) {
      this.__CarSearch.activateNext();
    }
    else {
      this.__CarSearch.activatePrev();
    }
    document.documentElement.classList.add('no-slideup-animm');
    if (this.nextprevTimer) {
      clearTimeout(this.nextprevTimer);
      this.nextprevTimer = null;
    }
    this.nextprevTimer = setTimeout(() => {
      document.documentElement.classList.remove('no-slideup-animm');
    }, 1000);
  }
}

ResultItem.prototype.templateLead = doT.template(
  $("#tpl_result_item_lead").html()
);

ResultItem.prototype.templateDetails = doT.template(
  $("#tpl_result_item_details").html()
);
// router.setPathPort({path: t.data.path, silent: true});
ResultItem.prototype._events = {
  activateOrOrigPicClick: function(e) {
    // const that = e.data;
    e.preventDefault();
    // if (that.expanded) {
    //   window.open(this.href, '_blank');
    // }
    // else {
    //   that.activateItem();
    // }
  },
  activateToggle(e) {
    const that = e.data;
    if (that.expanded) {
      that.inactivateItem();
    }
    else {
      that.activateItem();
    }
    e.preventDefault();
  },
  activateCtaClick(e) {
    const that = e.data;
    const hash = that.__CarSearch.formid + '-rfo';
    that.activateItem({hash});
    e.preventDefault();
  },
  activateClick(e) {
    const that = e.data;
    const $targetA = $(e.target).closest('a');
    if ($targetA.length && $targetA[0].href.search(rx.is_asset) > -1) {
      // console.log('do nothing');
    }
    else {
      that.activateItem();
      e.preventDefault();
    }
  },
  inactivateClick(e) {
    e.data.inactivateItem();
    e.preventDefault();
  },
  toggleSliderSize() {
    document.documentElement.classList.toggle('full-size-slider');
  },
  prevItem(e) {
    e.data.stepItem(false);

  },
  nextItem(e) {
    e.data.stepItem(true);
  },
  toggleAddress(e) {
    if (e.type === 'keypress' && e.which !== 13 && e.which !== 32) { return; }
    e.preventDefault();

    const that = e.data;
    const id = e.target.getAttribute('data-dlrid');
    const $target = that.$details.find(`#foot-addresses .${id}`);

    if ($target.length) {
      if (!$target.hasClass('active')) {
        $target.find(`.dealer-address-label`).click();
      }
      that.detailsScrollTo($target);
    }
  }
};



export default ResultItem;
